import { Component } from '@angular/core';
import {MenuService} from "../../services/menu-service";
import { UtilityService } from 'src/app/services/utility.service';

@Component({
    selector: 'app-body',
    templateUrl: './body.component.html',
    styleUrls: ['./body.component.css'],
    standalone: false
})
export class BodyComponent  {
  constructor(
    protected menuService: MenuService,
    private utility: UtilityService) {
  }

  UserIsEnabled() : boolean
  {
    return this.utility.GetUserIsEnabled();
  }
}
